<template>
  <div class="notification-area">
    <Notification
      v-for="notification in queue"
      :key="notification.id"
      :notification="notification"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useNotifications } from "@/common/notification";
import Notification from "@/components/notification/Notification.vue";

export default defineComponent({
  components: { Notification },
  setup() {
    const { queue } = useNotifications();

    return { queue };
  },
});
</script>

<style scoped lang="scss">
.notification-area {
  width: min(600px, 80vw);

  margin-bottom: 16px;

  display: flex;
  flex-flow: column nowrap;
  gap: 16px;
}
</style>
